import { GraphColorObject } from '../types/erd';
import { NeutralColor, PrimaryColor, SecondaryColor } from './colors.constant';

export const NODE_DIMENSIONS = {
  BASE_WIDTH: 90,
  CHAR_WIDTH: 8,
  PADDING: 20,
  MAX_WIDTH: 250,
  HEIGHT: 54,
} as const;

export const ERD_DIMENSIONS = {
  DEFAULT_WIDTH: 1400,
  DEFAULT_HEIGHT: 800,
  DEBOUNCE_DELAY: 300,
} as const;

export const EDGE_RENDERING = {
  DEFAULT_STROKE_WIDTH: 2.5,
  HIGHLIGHTED_STROKE_WIDTH: 4.5,
  SELF_LOOP_SIZE: 80,
  ARROW_SIZE: 10,
  BADGE_RADIUS: 14,
  BADGE_FONT_SIZE: '11px',
} as const;

export const GRAPH_COLORS: GraphColorObject[] = [
  { background: PrimaryColor.PURPLE, color: 'white' },
  { background: PrimaryColor.ORANGE, color: 'black' },
  { background: PrimaryColor.PINK, color: 'black' },
  { background: PrimaryColor.CYAN, color: 'black' },
  { background: PrimaryColor.RED, color: 'white' },
  { background: PrimaryColor.BLUE, color: 'white' },
  { background: PrimaryColor.GREEN, color: 'black' },
  { background: PrimaryColor.YELLOW, color: 'black' },
  { background: SecondaryColor.PURPLE, color: 'white' },
  { background: SecondaryColor.ORANGE, color: 'black' },
  { background: SecondaryColor.PINK, color: 'white' },
  { background: SecondaryColor.CYAN, color: 'white' },
  { background: SecondaryColor.RED, color: 'white' },
  { background: SecondaryColor.BLUE, color: 'white' },
  { background: NeutralColor.PURPLE, color: 'white' },
  { background: NeutralColor.ORANGE, color: 'white' },
  { background: NeutralColor.PINK, color: 'white' },
  { background: NeutralColor.CYAN, color: 'white' },
  { background: NeutralColor.RED, color: 'white' },
  { background: NeutralColor.BLUE, color: 'white' },
];